import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productsFilter'
})
export class ProductsFilterPipe implements PipeTransform {

  transform(items: any[], sortBy: any): any {
    if (!items) {
      return items;
    }

    let sortList = [];

    switch (sortBy) {
      case 'Title': //A to Z
        sortList = items.sort((a, b) => {
          var textA = a.Title.toUpperCase();
          var textB = b.Title.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        break;
      case '-Title': //Z to A
        sortList = items.sort((a, b) => {
          var textA = a.Title.toUpperCase();
          var textB = b.Title.toUpperCase();
          return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
        })
        break;
      case 'Price': //Low to High
            sortList = items.sort((a, b) => {
                {
                    let priceA: any = 0;
                    let priceB: any = 0;
                    if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
                        let variationA = a.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
                    }
                    else {
                        priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
                    }

                    if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
                        let variationB = b.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
                    }
                    else {
                        priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
                    }

                    return parseFloat(priceA) - parseFloat(priceB);
                }
            });
        break;
      case '-Price': //High to Low
            sortList = items.sort((a, b) => {
                let priceA: any = 0;
                let priceB: any = 0;
                if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
                    let variationA = a.VariationsData.reduce((prev, curr) => {
                        let variationPriceA = prev.VariationPrice;
                        let variationPriceB = curr.VariationPrice;
                        if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                            if (prev.VariationOnSale) {
                                variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                            } else
                                variationPriceA = prev.VariationPrice;
                            if (curr.VariationOnSale) {
                                variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                            } else
                                variationPriceB = curr.VariationPrice;
                        }
                        return variationPriceA < variationPriceB ? prev : curr
                    });
                    priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
                }
                else {
                    priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
                }

                if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
                    let variationB = b.VariationsData.reduce((prev, curr) => {
                        let variationPriceA = prev.VariationPrice;
                        let variationPriceB = curr.VariationPrice;
                        if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                            if (prev.VariationOnSale) {
                                variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                            } else
                                variationPriceA = prev.VariationPrice;
                            if (curr.VariationOnSale) {
                                variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                            } else
                                variationPriceB = curr.VariationPrice;
                        }
                        return variationPriceA < variationPriceB ? prev : curr
                    });
                    priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
                }
                else {
                    priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
                }

                return parseFloat(priceB) - parseFloat(priceA);
            });
        break;
      case '-PointStoreProductID': //Oldest to Newest
        sortList = items.sort((a, b) => (a.PointStoreProductID > b.PointStoreProductID) ? 1 : -1)
        break;
      case 'PointStoreProductID': //Newest to Oldest
        sortList = items.sort((a, b) => (a.PointStoreProductID < b.PointStoreProductID) ? 1 : -1)
        break;
    }

    return sortList;
  }

}
